import { Checkbox, FormControl } from '@mui/material';
import { useField } from 'formik';
import React from 'react';
import useGetCombinedEvents from './hooks/useGetCombinedEvents';
import { CheckboxWrapper, StyledLabel } from './StylovyzeForms.styles';
import { FORM_MODES } from '../../utils';
import { useMode } from './contexts/StylovyzeFormContext';
import { ItemWithLabel } from '../Items';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts/GlobalizationProvider';
export default function InputCheckbox(props) {
    const { t } = useGlobalization();
    const { fieldAttrs, checkbox, dataCy } = props;
    const mode = useMode();
    const [field] = useField(fieldAttrs);
    const combinedEvents = useGetCombinedEvents({
        fieldAttrs,
        onChange: props.onChange,
        onDebounceChange: props.onDebounceChange,
    });
    return (React.createElement(FormControl, { fullWidth: props.fullWidth }, mode === FORM_MODES.VIEW ? (React.createElement(ItemWithLabel, { label: props.label, value: field.value
            ? props.trueText ??
                t('True', {
                    context: 'Boolean value',
                })
            : props.falseText ??
                t('False', {
                    context: 'Boolean value',
                }) })) : (React.createElement(CheckboxWrapper, null,
        React.createElement(Checkbox, { className: props.className, ...field, color: checkbox.color || 'primary', inputProps: { contentEditable: false }, "data-cy": dataCy, name: field.name, id: field.name, value: Boolean(field.value), defaultChecked: Boolean(field.value), ...checkbox, onChange: (e) => {
                combinedEvents.onChange(e);
            }, disabled: props.fieldAttrs.disabled }),
        React.createElement(StyledLabel, { htmlFor: field.name }, props.label)))));
}
